import script from "./FilePreviewDemo.vue?vue&type=script&setup=true&lang=js"
export * from "./FilePreviewDemo.vue?vue&type=script&setup=true&lang=js"

import "./FilePreviewDemo.vue?vue&type=style&index=0&id=67e1a5f9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67e1a5f9"]])

export default __exports__